import * as React from 'react';
import { IArticleListCard } from 'models/magazine/article/articlelistcard';
import { IItemCardProps } from 'models/itemcard';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
import { INodeData } from 'models/common';
import moment = require('moment');
import { Tags } from 'components/Magazine/Article/Tag/Tags';

interface IProps extends IItemCardProps {
	item: IArticleListCard;
	t?: (key: string, options?: any) => string;
}
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class SimilarArticleDesktopItemCard extends React.Component<IProps, any> {
	constructor(props) {
		super(props);

		this.goToCard = this.goToCard.bind(this);
	}

	private goToCard(e: any) {
		e.preventDefault();
		if (this.props.goToCard) {
			const entityIdObj: INodeData = JSON.parse(this.props.item.entityId);
			this.props.goToCard(entityIdObj.id, entityIdObj.type);
		}
	}

	public render() {
		const { item, t } = this.props;
		const id = JSON.parse(item.entityId).id;

		return (
			<div key={id} className="col-lg-12 no_pad similarArticleDesktopItemCard d-flex flex-row">
				<div onClick={this.goToCard} className="singlePostImage" style={{ backgroundImage: `url(${item.picture})` }} />
				<div className="info">
					<Tags tags={item.tags} displayNumber={2} onClick={false} />
					<h3 className="title" onClick={this.goToCard}>
						{item.name}
					</h3>
					<p className="author p12">{t('BSPortal_Common_By').toUpperCase() + ' ' + item.addedBy.toUpperCase()}</p>
					<p className="date p12 grayGigo">{moment(item.addedDate).format('L')}</p>
				</div>
			</div>
		);
	}
}

export { SimilarArticleDesktopItemCard };
